// extracted by mini-css-extract-plugin
module.exports = {"smallHeader":"styles_smallHeader__d8xMJ","smallHeaderNav":"styles_smallHeaderNav__7tpsQ","smallHeaderItem":"styles_smallHeaderItem__wiUd8"};